import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {userRegister} from "../../services/userRegister";
import {langRegister} from "../../services/langRegister";
import queryString from 'query-string';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {cartRegister} from "../../services/cartRegister";
import BoosterHeader from "../../components/booster-header/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class BoosterLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingButton: false,
            error: false,
            email: "",
            password: "",
            private: false
        };
    };

    componentWillMount(){
        window.scrollTo(0, 0);
        //document.addEventListener("keydown", this._handleKeyDown.bind(this));
        this._checkToken();
        this._checkPrivate();

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/login');
            ReactGA4.send({ hitType: "pageview", page: "/login" });
        }
        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }
    }

    componentWillUnmount() {
        //document.removeEventListener("keydown", this._handleKeyDown.bind(this));
    }

    _handleKeyDown(event){
        var ENTER_KEY = 13;
        switch( event.keyCode ) {
            case ENTER_KEY:
                this._register();
                break;
            default:
                break;
        }
    }

    _checkToken(){
        let token = tokenRegister.get();
        if(token){
            let query = queryString.parse(this.props.location.search);
            if(query.from_path){
                this.props.history.push(query.from_path);
            }else if(query.to){
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + query.to);
            }else{
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/user/campaigns/running");
            }
        }
    }

    _checkPrivate(){
        if(salesChannelRegister.get("private")){
            this.setState({private: salesChannelRegister.get("private")});
        }
    }

    _signup() {
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/register");
    }

    _register() {
        this.setState({isLoadingButton: true, error: false});
        let user = {email: this.state.email, password: this.state.password};
        dataRegister.login(salesChannelRegister.get('market'), user).then((response) => {
            if(!response.errors){
                response.email = this.state.email;

                //GOOGLE EVENT
                if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                    ReactGA.event({category: 'User', action: 'Signed In', label: 'Login'});
                    ReactGA4.event({category: 'User', action: 'Signed In', label: 'Login'});
                }

                //FACEBOOK EVENT
                if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                    ReactPixel.trackCustom('SignIn');
                }

                try {
                    if(response.socialData){
                        if(response.socialData.image){
                            salesChannelRegister.set('socialIcon-salesforce', salesChannelRegister.get('socialIcon'));
                            salesChannelRegister.set('socialIcon', response.socialData.image);
                        }
                        if(response.socialData.title){
                            salesChannelRegister.set('socialTitle-salesforce', salesChannelRegister.get('socialTitle'));
                            salesChannelRegister.set('socialTitle', response.socialData.title);
                        }
                        if(response.socialData.facebookID){
                            salesChannelRegister.set('facebookId-salesforce', salesChannelRegister.get('facebookId'));
                            salesChannelRegister.set('facebookId', response.socialData.facebookID);
                        }
                        if(response.socialData.instagramID){
                            salesChannelRegister.set('instagramId-salesforce', salesChannelRegister.get('instagramId'));
                            salesChannelRegister.set('instagramId', response.socialData.instagramID);
                        }
                    }
                }catch (e) {}

                userRegister.set(response);
                let query = queryString.parse(this.props.location.search);
                if(query.from_path){
                    this.props.history.push(query.from_path);
                }else if(query.from){
                    this.props.history.push(query.from);
                }else if(query.to){
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + query.to);
                }else if(query.url){
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "?url=" + query.url);
                }else if(query.new){
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/options");
                }else{
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
                }
            }else{
                this.setState({isLoadingButton: false, error: true});
            }
        }, (error) => {
            this.setState({isLoadingButton: false, error: true});
        });
    }

    _forgot(){
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/forgot-password");
    }

    _renderButton() {
        if (!this.state.isLoadingButton) {
            return (this._renderText("item_5"));
        } else {
            return (<BeatLoader size={9} color={'#ffffff'} loading={true}/>);
        }
    }

    _renderText(item) {
        return langRegister.get("login-nopin", item);
    }

    render() {
        return (
            <div>
                <BoosterHeader view={"login"} props={this.props}/>
                <div className={Styles.container}>
                    <div style={salesChannelRegister.get('name') === "yieldlock"?{color: '#E65032'}:{}} className={Styles.title}>
                        {this._renderText("item_1")}
                    </div>
                    <div className={Styles.subtitle}>
                        {this._renderText("item_2")}
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={cx(Styles.input)}
                            type={"email"}
                            placeholder={this._renderText("item_3")}
                            value={this.state.email}
                            onChange={(event) => this.setState({email: event.target.value})}
                        />
                        {
                            this.state.error &&
                            <div style={salesChannelRegister.get('name') === "yieldlock"?{backgroundColor: '#E65032'}:{}} className={Styles.inputError}/>
                        }
                    </div>
                    <div className={Styles.inputWrapper}>
                        <input
                            className={cx(Styles.inputPassword)}
                            type={"password"}
                            placeholder={this._renderText("item_4")}
                            value={this.state.password}
                            onChange={(event) => this.setState({password: event.target.value})}
                        />
                        <div onClick={() => this._forgot()} className={Styles.inputPasswordForgot} style={salesChannelRegister.get("name") === "yieldlock"?{color: '#E65032'}:{}}>
                            {this._renderText("item_8")}
                        </div>
                        {
                            this.state.error &&
                            <div style={salesChannelRegister.get('name') === "yieldlock"?{backgroundColor: '#E65032'}:{}} className={Styles.inputError}/>
                        }
                    </div>
                    <div onClick={() => this._register()} className={Styles.button}>
                        {this._renderButton()}
                    </div>
                    {
                        <div className={Styles.text}>
                            {this._renderText("item_6")}<span onClick={() => this._signup()} className={Styles.textBold}>{this._renderText("item_7")}</span>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default BoosterLogin;


// WEBPACK FOOTER //
// ./src/pages/booster-login/component.js